export const SETTEXT = 'SETTEXT'
export const SETPHONEMESSAGE = 'SETPHONEMESSAGE'
export const SETSMSMESSAGE = 'SETSMSMESSAGE'
export const SETEMAILMESSAGE = 'SETEMAILMESSAGE'
